import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBendClosedSm = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 25 25",
	...props,
	children: [
		/* @__PURE__ */ _jsx("g", {
			id: "white",
			children: /* @__PURE__ */ _jsx("path", {
				className: "icon-white",
				d: "M17.11,3.05c-.22-.13-.45-.11-.62-.04L7.34,8.3c-.17,.08-.28,.27-.28,.55v3.11l.83,.48v9.13l.83,.48,9.22-5.32V4.48c0-.53-.38-1.16-.83-1.43Z"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			id: "grey",
			children: /* @__PURE__ */ _jsx("path", {
				className: "icon-outline",
				d: "M17.24,2.83c-.26-.16-.58-.18-.86-.05L7.21,8.08c-.26,.13-.41,.41-.41,.78v3.11c0,.09,.05,.18,.13,.22l.7,.4v8.98s0,.04,.01,.08c0,.01,.01,.03,.03,.06,.01,.02,.02,.03,.04,.05,.01,.01,.03,.03,.05,.04l.83,.48s.08,.03,.13,.03,.09-.01,.13-.04l9.22-5.32c.08-.05,.13-.13,.13-.23V4.48c0-.61-.42-1.33-.96-1.66Zm-8.27,6.86c-.02-.27-.12-.56-.28-.83-.17-.29-.39-.53-.63-.68L16.6,3.25s.21-.07,.37,.03c.38,.23,.7,.78,.7,1.21v12.08l-8.7,5.02V9.81s0-.08,0-.12Zm-1.09-.42c-.14,0-.26,.12-.26,.26v2.46l-.31-.18v-2.96c0-.16,.05-.28,.12-.31,.07-.03,.19,0,.32,.06,.04,.02,.07,.04,.11,.07,.14,.11,.28,.27,.39,.45,.09,.16,.16,.33,.19,.5,0,.04,.01,.07,.02,.11,0,.03,0,.05,0,.08v11.79l-.31-.18V9.53c0-.14-.12-.26-.26-.26Zm-.14,12.37h0Z"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			id: "color",
			children: /* @__PURE__ */ _jsxs("g", { children: [
				/* @__PURE__ */ _jsx("path", {
					className: "icon-highlight",
					d: "M10.9,8.21l-.74,.43c-.07,.04-.11,.1-.13,.17s0,.15,.03,.22c.05,.09,.15,.14,.25,.14,.05,0,.1-.01,.14-.04l.74-.43c.07-.04,.11-.1,.13-.17,.02-.07,0-.15-.03-.22-.08-.14-.26-.18-.39-.11Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "icon-highlight",
					d: "M9.43,9.07l-.74,.43c-.07,.04-.11,.1-.13,.18-.02,.07,0,.15,.03,.22,.05,.09,.15,.14,.25,.14,.05,0,.1-.01,.14-.04l.74-.43c.14-.08,.19-.26,.11-.39-.08-.14-.26-.19-.39-.11Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "icon-highlight",
					d: "M12.6,7.33c-.07-.02-.15,0-.22,.03l-.74,.43c-.14,.08-.18,.26-.11,.39,.05,.09,.15,.14,.25,.14,.05,0,.1-.01,.14-.04l.74-.43c.07-.04,.11-.1,.13-.17,.02-.07,0-.15-.03-.22-.04-.07-.1-.11-.17-.13Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "icon-highlight",
					d: "M18.08,4.4c-.04-.07-.1-.11-.17-.13-.07-.02-.15-.01-.22,.03l-.15,.09c-.14,.08-.18,.26-.11,.39,.05,.09,.15,.14,.25,.14,.05,0,.1-.01,.14-.04l.15-.09c.07-.04,.11-.1,.13-.17,.02-.07,0-.15-.03-.22Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "icon-highlight",
					d: "M13.85,6.51l-.74,.43c-.07,.04-.11,.1-.13,.17-.02,.07,0,.15,.03,.22,.05,.09,.15,.14,.25,.14,.05,0,.1-.01,.14-.04l.74-.43c.14-.08,.18-.26,.11-.39-.08-.14-.26-.19-.39-.11Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "icon-highlight",
					d: "M17.02,4.78c-.08-.02-.15,0-.22,.03l-.74,.43c-.14,.08-.19,.26-.11,.39,.05,.09,.15,.14,.25,.14,.05,0,.1-.01,.14-.04l.74-.43c.07-.04,.11-.1,.13-.17,.02-.07,0-.15-.03-.22-.04-.07-.1-.11-.17-.13Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "icon-highlight",
					d: "M15.33,5.66l-.74,.43c-.14,.08-.18,.26-.1,.39,.05,.09,.15,.14,.25,.14,.05,0,.1-.01,.14-.04l.74-.43c.07-.04,.11-.1,.13-.17,.02-.07,0-.15-.03-.22-.08-.14-.26-.18-.39-.1Z"
				})
			] })
		})
	]
});
export default SvgBendClosedSm;
